import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import AppsLayout from "./AppsLayout";
import AppsHome from "./pages/AppsHome";
import GmailCollapseAll from "./pages/GmailCollapseAll";
import GmailCollapseAllPrivacy from "./pages/GmailCollapseAllPrivacy";
import Support from "./pages/Support";

const InverluxApps = () => (
  <Routes>
    <Route element={<AppsLayout />}>
      <Route path="/" element={<AppsHome />} />
      <Route path="/gmail-collapse-all" element={<GmailCollapseAll />} />
      <Route
        path="/gmail-collapse-all/privacy"
        element={<GmailCollapseAllPrivacy />}
      />
      <Route path="/support" element={<Support />} />
    </Route>
    <Route path="*" element={<Navigate to="/" replace />} />
  </Routes>
);

export default InverluxApps;
